"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBTC = void 0;
const deposits_1 = require("./deposits");
const maintenance_1 = require("./maintenance");
const redemptions_1 = require("./redemptions");
const bitcoin_1 = require("../lib/bitcoin");
const ethereum_1 = require("../lib/ethereum");
const electrum_1 = require("../lib/electrum");
/**
 * Entrypoint component of the tBTC v2 SDK.
 */
class TBTC {
    constructor(tbtcContracts, bitcoinClient) {
        this.deposits = new deposits_1.DepositsService(tbtcContracts, bitcoinClient);
        this.maintenance = new maintenance_1.MaintenanceService(tbtcContracts, bitcoinClient);
        this.redemptions = new redemptions_1.RedemptionsService(tbtcContracts, bitcoinClient);
        this.tbtcContracts = tbtcContracts;
        this.bitcoinClient = bitcoinClient;
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint for Ethereum and Bitcoin mainnets.
     * The initialized instance uses default Electrum servers to interact
     * with Bitcoin mainnet
     * @param signer Ethereum signer.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @throws Throws an error if the signer's Ethereum network is other than
     *         Ethereum mainnet.
     */
    static async initializeMainnet(signer) {
        return TBTC.initializeEthereum(signer, "mainnet", bitcoin_1.BitcoinNetwork.Mainnet);
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint for Ethereum Goerli and Bitcoin testnet.
     * The initialized instance uses default Electrum servers to interact
     * with Bitcoin testnet
     * @param signer Ethereum signer.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @throws Throws an error if the signer's Ethereum network is other than
     *         Ethereum mainnet.
     */
    static async initializeGoerli(signer) {
        return TBTC.initializeEthereum(signer, "goerli", bitcoin_1.BitcoinNetwork.Testnet);
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint for Ethereum Sepolia and Bitcoin testnet.
     * The initialized instance uses default Electrum servers to interact
     * with Bitcoin testnet
     * @param signer Ethereum signer.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @throws Throws an error if the signer's Ethereum network is other than
     *         Ethereum mainnet.
     */
    static async initializeSepolia(signer) {
        return TBTC.initializeEthereum(signer, "sepolia", bitcoin_1.BitcoinNetwork.Testnet);
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint for the given Ethereum network and Bitcoin network.
     * The initialized instance uses default Electrum servers to interact
     * with Bitcoin network.
     * @param signer Ethereum signer.
     * @param ethereumNetwork Ethereum network.
     * @param bitcoinNetwork Bitcoin network.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @throws Throws an error if the underlying signer's Ethereum network is
     *         other than the given Ethereum network.
     */
    static async initializeEthereum(signer, ethereumNetwork, bitcoinNetwork) {
        const signerAddress = await (0, ethereum_1.ethereumAddressFromSigner)(signer);
        const tbtcContracts = await (0, ethereum_1.loadEthereumContracts)(signer, ethereumNetwork);
        const bitcoinClient = electrum_1.ElectrumClient.fromDefaultConfig(bitcoinNetwork);
        const tbtc = new TBTC(tbtcContracts, bitcoinClient);
        // If signer address can be resolved, set it as default depositor.
        if (signerAddress !== undefined) {
            tbtc.deposits.setDefaultDepositor(signerAddress);
        }
        return tbtc;
    }
    /**
     * Initializes the tBTC v2 SDK entrypoint with custom tBTC contracts and
     * Bitcoin client.
     * @param tbtcContracts Custom tBTC contracts handle.
     * @param bitcoinClient Custom Bitcoin client implementation.
     * @returns Initialized tBTC v2 SDK entrypoint.
     * @dev This function is especially useful for local development as it gives
     *      flexibility to combine different implementations of tBTC v2 contracts
     *      with different Bitcoin networks.
     */
    static async initializeCustom(tbtcContracts, bitcoinClient) {
        return new TBTC(tbtcContracts, bitcoinClient);
    }
}
exports.TBTC = TBTC;
//# sourceMappingURL=tbtc.js.map